import React from "react";
import ReactDOM from "react-dom";

import {MC} from './MC.js';

class Button extends React.Component {

  state = {rippleStyle: {}}

  componentWillUnmount() {
    clearTimeout(this.timer)
    clearTimeout(this.timerAfter)
  }

  handleClick = (ev) => {
    var field = this.props.button;
    if (field.flow.getCfgParameter("mini:buttonRipple") === 'true') {
      this.ripple(ev)
    }
    var behavior = MC.getFieldParamValue(field.param, '@behavior')
    if (behavior == 'url') {
      var url = MC.getFieldParamValue(field.param, '@url')
      if (window && !MC.isNull(url) && url !== '') {
        var newWindow =  MC.getFieldParamBooleanValue(field.param, '@newWindow')
        if (newWindow) {
          window.open(url)
        } else {
          window.location.href = url
        }
      }
    } else if (behavior == 'dialog') {
      field.flow.callDialog(field)
    } else {
      if (MC.isFunction(this.props.button.onSubmit) && !MC.isModelerActive(this.props.button)) {
        this.props.button.onSubmit(this.props.button)
      }
    }
  }

  ripple(ev) {
    var elem = ReactDOM.findDOMNode(this);
    var pos = MC.getElemCoords(elem);
    var rect = elem.getBoundingClientRect();
    var left = ev.pageX - pos.left;
    var top = ev.pageY - pos.top;
    var size = Math.max(rect.width, rect.height);
    this.setState({ rippleStyle: {top: top, left: left, opacity: 1, transform: 'translate(-50%, -50%)', transition: 'initial', width: '35px', height: '35px'} });
    this.timer = setTimeout(() => {
      this.setState({ rippleStyle:  {top: top, left: left, opacity: 0, transform: 'scale(' + size / 9 + ')', transition: 'all 600ms', width: '35px', height: '35px'}});
      this.timerAfter = setTimeout(() => {
        this.setState({ rippleStyle:  {width: '0px', height: '0px'}})
      }, 600);
    });
  }

  render() {
    var field = this.props.button;
    let label = this.props.value
    const labelPlacement = MC.getFieldParamValue(field.param, '@titlePlacement')
    if (labelPlacement == 'IN') {
      label = MC.getFieldParamValue(field.param, '@title')
    }
    var icon = MC.getFieldParamValue(field.param, '@icon')
    if (!MC.isNull(icon) && icon != "") {
      let cls = 'icon ' + icon;
      icon = <i className={cls}></i>
    } else {
      icon = null
    }
    var value = this.props.value ? this.props.value : label;
    let cls = MC.getFieldParamValue(field.param, '@cssClass')
    cls = cls ? 'ui button ripper-wrapper ' + cls : 'ui button ripper-wrapper'
    return (
      <button type="button" className={cls} ref={field.rbsid} value={value} disabled={this.props.disabled} onClick={this.handleClick} data-widget-i-name={field.id}>
        {icon}{label}
        <s style={this.state.rippleStyle} className="ripper"/>
      </button>
    )
  }
}

export {Button}